import request from '@/utils/request'

// 获取 table 数据 /css-report/page
export const getTableData = params =>
  request.post('/customer-api/css-report/page', params)

// 新增 /css-report/add
export const add = params =>
  request.post('/customer-api/css-report/add', params)

// 下载
export const download = params =>
  request.get(`/customer-api/file/download`, params, { responseType: 'blob' })

// 查询
export const search = params =>
  request.post(`/customer-api/css-report/page`, params)
